import { Injectable } from '@angular/core';

import { DocumentFormComponent } from '../../components/documents/document-form/document-form.component';
import { DocumentFormUploadComponent } from '../../components/documents/document-form-upload/document-form-upload.component';
import { DocumentSidebarComponent } from '../../components/documents/document-sidebar/document-sidebar.component';
import { MatterDocumentsListComponent } from '../../components/matters/matter-documents-list/matter-documents-list.component';

@Injectable()
export class DocumentStoreService {
  documentFormComponent: DocumentFormComponent | null;
  documentFormUploadComponent: DocumentFormUploadComponent | null;
  documentSidebarComponent: DocumentSidebarComponent | null;
  matterDocumentsListComponent: MatterDocumentsListComponent | null;

  constructor() {}
}
